import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { MaterialId } from '@core/constants/Material';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import {
    allMaterials,
    allMetals,
    allCeramics,
    allConcretes,
    allMarbleAndStones,
    getMaterialsWithExceptions,
    allSolidWoods,
} from './common/materialGroups';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import { tableTrayShapeDimension } from './common/fieldsTrayShapeDimension';
import { fieldExtension } from './common/fieldExtension';
import { allBorders, allLegs } from './common/shapesGroups';
import { fieldsLegsDimension } from './common/fieldsLegsDimension';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const tableForm: IForm = {
    formId       : PublishedFormId.Table,
    type         : FormTypeId.Table,
    thumbnailURL : '/resized-images/forms/table.jpg',
    imagesURLs   : [
        '/resized-images/forms/description/table/table1.jpg',
        '/resized-images/forms/description/table/table2.jpg',
        '/resized-images/forms/description/table/table3.jpg',
        '/resized-images/forms/description/table/table4.jpg',
        '/resized-images/forms/description/table/table5.jpg',
        '/resized-images/forms/description/table/table6.jpg',
        '/resized-images/forms/description/table/table7.jpg',
        '/resized-images/forms/description/table/table8.jpg',
        '/resized-images/forms/description/table/table9.jpg',
    ],
    fieldsOrder: [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.TrayShapeDimension,
        IFormFieldKey.TrayMaterial,
        IFormFieldKey.Border,
        IFormFieldKey.Extension,
        IFormFieldKey.LegsShape,
        IFormFieldKey.LegsMaterial,
        IFormFieldKey.LegsDimension,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        trayShapeDimension : tableTrayShapeDimension,
        trayMaterial       : {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(allMaterials,
                    [
                        MaterialId.BlackLocust,
                        MaterialId.Iroko,
                        MaterialId.Douglas,
                        MaterialId.DouglasEngineered,
                        MaterialId.DouglasRecycled,
                        MaterialId.DouglasVeneer,
                        MaterialId.Padouk,
                        MaterialId.PadoukEngineered,
                        MaterialId.PadoukRecycled,
                        MaterialId.PadoukVeneer,
                        MaterialId.Ipe,
                        MaterialId.IpeRecycled,
                        MaterialId.IpeEngineered,
                        MaterialId.IpeVeneer,
                        MaterialId.Garapa,
                        MaterialId.Aluminum,
                        MaterialId.Zinc,
                        MaterialId.Brass,
                        MaterialId.PlexiglassFluorescent,
                        MaterialId.PlexiglassFrosted,
                        MaterialId.PlexiglassMirror,
                        MaterialId.PlexiglassTransparent,
                        MaterialId.PlexiglassWhite,
                        MaterialId.PolycarbonateOpaque,
                        MaterialId.PolycarbonateTeinted,
                        MaterialId.PolycarbonateTransparent,
                        MaterialId.Pvc,
                        MaterialId.PvcRigid,
                    ]),
                required: true,
            },
        },
        border: {
            value    : undefined,
            options  : allBorders,
            required : true,
        },
        extension : fieldExtension,
        legsShape : {
            value    : undefined,
            options  : allLegs,
            required : true,
        },
        legsMaterial: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allMetals,
                        ...allSolidWoods,
                        ...allConcretes,
                        ...allCeramics,
                        ...allMarbleAndStones,
                    ],
                    [
                        MaterialId.BlackLocust,
                        MaterialId.Iroko,
                        MaterialId.Douglas,
                        MaterialId.Redcedar,
                        MaterialId.Larch,
                        MaterialId.Padouk,
                        MaterialId.Ipe,
                        MaterialId.Garapa,
                        MaterialId.Brass,
                        MaterialId.Zinc,
                    ],
                ),
                required: true,
            },
        },
        legsDimension  : fieldsLegsDimension,
        additionalData : additionalDataFactory({
            budgetMin          : 1200,
            budgetMax          : 18000,
            budgetDefaultValue : 2700,
            marks              : budgetMarksBuilder(1200, 100, 6000, 500, 18000),
        }),
        contact: fieldsContact,
    },
};

export default tableForm;
